import { Typography } from '@design-system/components/typography/typography';
import * as styles from './Onboarding.css';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { bgColorsVars } from '@design-system/vars.css';
import { ChecklistCard } from './ChecklistCard';
import { ReactComponent as Arrow } from './pointer-arrow.svg';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type OnboardingProps = {
  checklist: Array<{
    title: string;
    done: boolean;
    to?: string;
    onClick?: () => void;
    icon: IconProp;
  }>;
  completed: number;
};

export const Onboarding = ({ checklist, completed }: OnboardingProps) => {
  if (checklist.length === 0) return null;
  return (
    <div className={styles.card}>
      <div className={styles.progressWrapper}>
        <Typography variant="body" size="large">
          Follow these three steps required to unlock the “Go live” button and
          start making 💸
        </Typography>
        <Arrow className={styles.arrow} />
        <div className="flex flex-col md:flex-row gap-4 items-center">
          <Typography
            variant="body"
            size="small"
            fontWeight="normal"
            color="N-100"
          >
            {completed}/3 completed
          </Typography>
          <div className="gap-1 flex flex-row">
            {Array(3)
              .fill(false)
              .map((_, i) => i < completed)
              .map((done, i) => (
                <div
                  key={i}
                  style={{
                    width: '100px',
                    height: '4px',
                    borderRadius: '4px',
                    backgroundColor: done
                      ? bgColorsVars['P-80']
                      : bgColorsVars['P-40'],
                  }}
                />
              ))}
          </div>
        </div>
      </div>
      <div className={styles.checklistWrapper}>
        {checklist.map(({ title, done, to, onClick, icon }) => (
          <ChecklistCard
            icon={icon || faCircleExclamation}
            key={title}
            title={title}
            isCompleted={done}
            link={to}
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
};
